import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { gettoken } from "../../../Localstorage/Store";

const ApplyCredit = ({ship,applycredit,orderid}) => {
  const { bgColor, textColor } = useSelector((state) => state.theam);
  const tokenvalue = gettoken();
  const buttonRef = useRef(null);
  const [otp, setotp] = useState('');
  const [otperror, setotperror] = useState('');
  const [mobileno, setmobileno] = useState("");
  const [realmobile,setrealmobile] = useState(0)

    const handleClick = () => {
        const buttonNode = buttonRef.current;
        if (buttonNode) {
        buttonNode.click();
        }
    };
    const userinfo = async () => {
      const config = {
        headers: {
          Authorization: `Bearer ${tokenvalue.access}`,
          "Content-Type": "application/json",
        },
      };
      let url = `${process.env.REACT_APP_API_URL}useraccount/clientinfo/`;
      try {
        const response = await axios.get(url, config);
        const countryCode = '+91'; 
        const maskedPart = 'XXXXXX';
        if (response.data.UserProfile) {
          setrealmobile(response.data.UserProfile.mobile_number);
          const visiblePart = response.data.UserProfile.mobile_number.slice(-4);
          setmobileno(`${countryCode}${maskedPart}${visiblePart}`);
        } else {      
          setrealmobile(response.data.ClientDetails.mobile_no);
          if (response.data.ClientDetails.mobile_no.startsWith(countryCode)){
          const countryCode2 = response.data.ClientDetails.mobile_no.substring(0, 3);
          const visiblePart = response.data.ClientDetails.mobile_no.slice(-4); 
          setmobileno(`${countryCode2}${maskedPart}${visiblePart}`);
          }else{
          const visiblePart = response.data.ClientDetails.mobile_no.slice(-4); 
          setmobileno(`${countryCode}${maskedPart}${visiblePart}`);
          }
         
       }
      } catch (error) {
      }
    }
    const sendotp = async () => {

        const formdata = new FormData()
        formdata.append('mobile_number', realmobile)
        formdata.append("shipping_charge", ship);
        formdata.append("order_number", orderid);


        

        const config = {
            headers: {
                Authorization: `Bearer ${tokenvalue.access}`,
            },
        };
        try {
            let url = `${process.env.REACT_APP_API_URL}credit/send-otp-save-cart/`;
            const response = await axios.post(url, formdata, config);
        } catch (error) {
        }
    }
    const verifyotp = async () => {

        const formdata = new FormData()
        formdata.append('mobile_number', realmobile)
        const config = {
            headers: {
                Authorization: `Bearer ${tokenvalue.access}`,
            },
        };
        try {
            const data = {
                'mobile_number': realmobile,
                'otp': otp,
            }
            let url = `${process.env.REACT_APP_API_URL}credit/verify-otp/`;
            const response = await axios.post(url, data, config);
            if (response.data.message == 'phone verified') {
                setotperror('')
                applycredit();
                handleClick()
            }
        } catch (error) {
            setotperror(error.response.data.message)
        }
    }


   useEffect(()=>{
     userinfo();
   },[])

    return (
        <div style={{ display: "flex", gap: 4 }}>

            <button
                className="btn"
                type='button'
                style={{
                    fontWeight: 500,
                    backgroundColor: `#${bgColor}`,

                    color: "white",
                    borderRadius: "0px",
                    fontSize: 12,
                    height: "fit-content",
                    padding: "7px 8px",
                }}
                data-bs-toggle="modal"
                data-bs-target="#exampleModaladdressone2otp"
                onClick={() => { sendotp() }}
            >
                Apply Credits
            </button>

















            <div
            class="modal fade"
            id="exampleModaladdressone2otp"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog newmargin3" style={{maxWidth: "570px" }}>
              <div class="modal-content">
                
                <div class="modal-body">
                 
                    
                        <div className="row check-out justify-content-center">
                         <div className="col-12 d-flex py-3 justify-content-center">
                          <h4 style={{fontSize:'22px'}}>Verify OTP</h4>
                         </div>
                          <div className="form-group col-md-11 col-sm-11 col-xs-11">
                            <label className="acounttitle m-0 pb-1">
                              OTP has Been Send to Your {mobileno}
                              {/* +91XXXXXX9471 */}
                              <span style={{ color: "red", fontSize: "13px" }}>
                                {" "}
                                *
                              </span>
                            </label>
                            {/* <input type="text" name="field-name" placeholder='First Name' /> */}

                            <input
                              type="text"
                              name="first_name"
                              className="form-control"
                              style={{ fontSize: "12px",height:'40px' }}
                              placeholder="Enter Your OTP"
                              value={otp}
                              onChange={(e)=>{setotp(e.target.value)}}
                             
                            />
                          
                          </div>

                          <div className="form-group col-md-12 col-sm-12 col-xs-12 cht">
                            <div className="payment-box">
                              <div
                                className="text-left"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "4px",
                                }}
                              >
                                <button
                                  type="button"
                                  style={{
                                    fontSize: "12px",
                                    background: "#bdbfc0",
                                    color: "#000",
                                  }}
                                  className="btn-normal btn"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                  ref={buttonRef}
                                >
                                  Cancel
                                </button>
                               {otp.length == 6 ? <button
                                  type="submit"
                                  onClick={()=>{console.log("first open state");verifyotp()}}
                                  style={{ fontSize: "12px" ,backgroundColor: `#${bgColor}` }}
                                  className="btn-normal btn"
                                >
                                  Verify
                                </button> : <button
                                  type="submit"
                                  disabled
                                  style={{ fontSize: "12px",backgroundColor: `#${bgColor}` }}
                                  className="btn-normal btn"
                                >
                                  Verify
                                </button>} 
                              </div>
                            </div>
                          </div>

                          <div className="d-flex justify-content-center">
                            {otperror == '' ? '' : <span style={{color:'red'}}>Incorrect OTP</span>}
                          </div>

                         
                        </div>
                    
                    
                </div>
               
              </div>
            </div>
          </div>
        </div>
    )
}

export default ApplyCredit